import useWindowDimensions from "../../hooks/useWindowDimensions";
import React from "react";

export const Additional = () => {
    const { height, width } = useWindowDimensions();
        const styleList ={
        additional:{
            fontSize:width > "768" ? "24px" : "18px",
            lineHeight: width > "768" ? "40px" : "28px",
        }
    }
    return(
        <>
            <div className={"brijesh_wrapper p-0"}>
                <div className={"container section_title_main project_wrapper pt-0 mt-4"}>
                    <h3 className={"section_title  mt-0 pt-0 pt-lg-5 mt-lg-5 mb-lg-5 mb-md-4 mb-0"}>Additional technologies and skills</h3>
                    <div className={"row px-lg-5 mx-lg-5 mx-5 mt-lg-0 mt-3 mx-4"}>
                        <div className={`col-sm-4 col-12`} style={styleList.additional}>
                            <ul style={{listStyle:"unset"}}>
                                <li className={"py-1 py-md-2"}>Browser Developer Tools</li>
                                <li className={"py-1 py-md-2"}>Web Parformance</li>
                                <li className={"py-1 py-md-2"}>B2 english</li>
                                <li className={"py-1 py-md-2"}>RWD</li>
                            </ul>
                        </div>
                        <div className={"col-sm-4 col-12"} style={styleList.additional}>
                            <ul style={{listStyle:"unset"}}>
                                <li className={"py-1 py-md-2"}>Quick learning</li>
                                <li className={"py-1 py-md-2"}>Teamwork</li>
                                <li className={"py-1 py-md-2"}>Graphics design</li>
                            </ul>
                        </div>
                        <div className={"col-sm-4 col-12"} style={styleList.additional}>
                            <ul style={{listStyle:"unset"}}>
                                {/* <li className={"py-1 py-md-2"}>Quick learning</li> */}
                                <li className={"py-1 py-md-2"}>Figma Design</li>
                                <li className={"py-1 py-md-2"}> Research and development</li>
                                <li className={"py-1 py-md-2"}>Frameworks and Libraries</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Additional;